import React, { useContext, useMemo } from 'react';

import AttachmentListItem from './attachmentListItem';
import assetModalContext from '../asset_modal_context';

import './styles/_attachment_list.scss';
import { AttachmentActionDispatch, FlattenedAttachment } from '../EditTabTypes';

interface AttachmentListProps {
  attachments: FlattenedAttachment[];
}

interface AttachmentListScopedContext {
  dispatch: AttachmentActionDispatch;
  state: {
    editState: AttachmentListProps;
  };
}

const AttachmentList = (): JSX.Element => {
  const { dispatch, state }: AttachmentListScopedContext = useContext(assetModalContext);
  const { attachments }: AttachmentListProps = state.editState;

  return useMemo(() => (
    <ul className="attachment-list">
      {(attachments.map((attachment, i) => (
        <AttachmentListItem
          attachment={attachment}
          dispatch={dispatch}
          index={i}
          key={attachment.key}
        />
      )))}
    </ul>
  ), [attachments, dispatch]);
};

export default AttachmentList;
